import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";

import '@/plugins/element'
import '@/plugins/global'
import '@babel/polyfill'

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");

import 'normalize.css/normalize.css'  // 样式重置
import '@/styles/index.scss'          // 基础样式
import '@/icons' // svg图标
